<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs>
        <!-- 策略组 -->
        <el-tab-pane label="">
          <span slot="label">{{ $t("customer.service_log") }}</span>
          <div class="main" v-if="this.table_role_show == 1">
            <p>
              <el-button
                @click="add_role_show_group()"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("customer.service_log_add") }}</el-button
              >
            </p>
          </div>
          <div class="switch1">
            <div
              class="table table_hover group_table"
              v-if="this.table_role_show == 1"
            >
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="group_fileList"
                class="table-fixed"
                v-loading="loading"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="60"
                >
                </el-table-column>

                <!-- 名称 -->

                <el-table-column
                  prop="NAME"
                  :label="$t('customer.user_name')"
                  width="126"
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.SHOW_POLICY_LIST"
                      placement="top"
                    >
                      <span> {{ scope.row.NAME }}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>

                <!-- 域名-->

                <el-table-column
                  prop="DOMAIN_NAME"
                  :label="$t('logs.group7_a4')"
                  width="130"
                >
                </el-table-column>

                <!-- ip-->

                <el-table-column
                  prop="IP"
                  :label="$t('logs.manage3')"
                
                >
                </el-table-column>

                <!-- mac-->

                <el-table-column
                  prop="MAC"
                  label="MAC"
                 
                >
                </el-table-column>
                
                <!-- 到期时间-->

                <el-table-column
                  prop="TIME"
                  :label="$t('logs.domain_1')"
                
                >
                </el-table-column>
                    
                <!-- 类型-->

                <el-table-column
                  prop="SHOW_TYPE"
                  :label="$t('logs.mode_switch17')"
                
                >
                </el-table-column>
                <el-table-column prop="address" :label="$t('table1.operation')" width="100">
                  <template slot-scope="scope">
                    <!-- 删除 -->
                    <el-button
                      @click="handleClick4(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                     <!-- 编辑 -->
                    <el-button
                      @click="handleClick_edit(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 添加 和编辑部分-->
            <div class="lie lie_add_role" v-if="this.table_role_add == 1">
              <div class="create_information" v-if="this.table_role_edit == 0">
                {{ $t("customer.service_log_add") }}
              </div>
              <div class="create_information" v-if="this.table_role_edit == 1">
                {{ $t("customer.service_log_edit") }}
              </div>

              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.customer_name_text }}:
                  </div>
                  <div class="block block1">
                    <p
                      v-if="this.table_role_edit == 1"
                      style="
                        text-align: left;
                        color: #0e2c5e;
                        margin: 8px 0px;
                        border-bottom: 0;
                      "
                    >
                      {{ this.customer_name }}
                    </p>
                    <el-input v-model="customer_name"  v-if="this.table_role_edit == 0"></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.domain_name_text }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="domain_name"></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.ip_text }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="type_ip"></el-input>
                  </div>
                </div>
                 <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.mac_text }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="customer_mac"></el-input>
                  </div>
                </div>
                 <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.time_text }}:
                  </div>
                  <div class="block block1">
                      <el-date-picker
                     class="picker_type"
      v-model="customer_time"
      type="date"
      placeholder="">
    </el-date-picker>
                  
                  </div>
                </div>
                 <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    {{ this.user_type_text }}:
                  </div>
                  <div class="block block1">
                     <el-select v-model="user_type" placeholder=""   class="picker_type">
    <el-option
      v-for="item in user_type_arr"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
                    
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px"></div>
                  <div class="block block1">
                    <el-button
                      type="primary"
                      @click="save_custom()"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("tab.save") }}</el-button
                    >

                    <el-button type="danger" @click="off_customer()">{{
                      $t("tab.cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table_role_show: 1,
      table_role_edit: 0,
      table_role_add: 0,
      newadd:1,
      group_fileList: [],
      loading: false,
      customer_name_text: "",
      domain_name_text: "",
      ip_text: "",
      customer_name: "",

      domain_name: "",
      type_ip: "",
      user_type:"",
      user_type_text:"",
      mac_text:"",
      customer_mac:'',
      time_text:"",
      customer_time:'',

user_type_arr:[],
    };
  },

  mounted() {
    this.getFileList_custom();
  },
  methods: {
    getFileList_custom() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      this.$axios
        .get("/api/adm/cgi/crm.cgi", {
          params: {
            __mode: "load_customer",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);
          this.loading = false;

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
          } else if (res.data.fmstatus.code == "3") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.group_fileList = res.data.ret.datalist;
            this.customer_name_text = res.data.ret.customer_name;
            this.domain_name_text = res.data.ret.domain_name;
            this.ip_text = res.data.ret.customer_ip;
            this.user_type_text = res.data.ret.customer_type;
            this.mac_text = res.data.ret.customer_mac;
            this.time_text = res.data.ret.customer_time;
            this.user_type_arr = res.data.ret.q_user_type;
          }
        });
    },

    save_custom() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      let str = this.$qs.stringify({
        __mode: "save_customer",
        sid: sid,
        custom_name: this.customer_name,
        domain_name: this.domain_name,
        customer_time: this.customer_time,
        customer_mac: this.customer_mac,
        customer_type: this.user_type,
        ip: this.type_ip,
        newadd:this.newadd,
      });
      //  console.log(str)
      this.$axios
        .post(
          "/api/adm/cgi/crm.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          console.log(res);
          this.$close_hint_test();
          this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            this.$message({
              type: "error",
              message: `${res.data.fmstatus.errmsg}`,
            });
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList_custom();
            this.table_role_add = 0;
            this.table_role_show = 1;
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    handleClick4(index, scope) {
      console.log(index, scope);
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let customer_name = scope.NAME;

          this.$axios
            .get("/api/adm/cgi/crm.cgi", {
              params: {
                __mode: "del_customer",
                sid: sid,
                custom_name: customer_name,
              },
            })
            .then((res) => {
              console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.getFileList_custom();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    handleClick_edit(index, scope) {
console.log(index,scope)
     this.customer_name=scope.NAME;
       this.domain_name=scope.DOMAIN_NAME;
         this.customer_time=scope.TIME;
        this.customer_mac=scope.MAC;
        this.user_type=scope.TYPE;
        this.type_ip=scope.IP;
  this.table_role_show = 0;
      this.table_role_edit = 1;
      this.table_role_add = 1;
      this.newadd=0;
    },
    // 显示
    add_role_show_group() {
      this.table_role_show = 0;
      this.table_role_edit = 0;
      this.table_role_add = 1;
      this.newadd=1;
       this.customer_name=''
       this.domain_name=''
         this.customer_time=''
        this.customer_mac=''
        this.user_type=''
        this.type_ip=''
    },
    // 过滤策略取消
    off_customer() {
      this.table_role_add = 0;
      this.table_role_show = 1;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";
@import "../../css/lie_add_role.less";

/deep/ .el-table th {
  text-align: left;
}

// 表格居中位置
/deep/ .el-table__row td {
  text-align: left;
}
.picker_type{
 
    width: 48% !important;
 
 /deep/ .el-input__inner{
    padding-left: 36px;
  }
}
</style>
